var render = function render(){var _vm=this,_c=_vm._self._c;return _c('sf-data-table',{ref:"pprNoTable",attrs:{"pageUnit":this.pprNoPagingInfo.pageUnit,"totalSize":this.pprNoPagingInfo.totalSize,"paging":"","columns":_vm.columns,"rows":_vm.pprNoPopupList,"stripe":false,"selection":false,"height":"520px","fit":"fit"},on:{"changedPage":_vm.changedPage}})
}
var staticRenderFns = []

export { render, staticRenderFns }